import React from 'react';
import { FaCalendarPlus } from 'react-icons/fa'; // Importing the "Add to Calendar" icon
import theme from "../theme/theme1";

const events = [
  {
    day: 'Monday',
    date: 'December 10',
    title: 'IP Office Hours',
    description:
      'Meet with a Quadrant-i Principal to discuss the patent process and commercialization opportunities for your research.',
    color: 'rgb(14 80 58)',
  },
  {
    day: 'Tuesday',
    date: 'December 11',
    title: 'IP Office Hours',
    description:
      'Meet with a Quadrant-i Principal to discuss the patent process and commercialization opportunities for your research.',
    color: 'rgb(14 80 58)',
  },
  {
    day: 'Friday',
    date: 'December 14',
    title: 'Annual Sports Day',
    description:
      'Meet with a Quadrant-i Principal to discuss the patent process and commercialization opportunities for your research.',
    color: 'rgb(14 80 58)',
  },
  {
    day: 'Tuesday',
    date: 'December 10',
    title: 'Bio LaunchPad Seminar',
    description:
      'Meet with a Quadrant-i Principal to discuss the patent process and commercialization opportunities for your research.',
    color: 'rgb(14 80 58)',
  },
  {
    day: 'Wednesday',
    date: 'December 18',
    title: 'Parent-Teacher Meeting',
    description:
      'Meet with a Quadrant-i Principal to discuss the patent process and commercialization opportunities for your research.',
    color: 'rgb(14 80 58)',
  },
  {
    day: 'Saturday',
    date: 'January 5',
    title: 'Educational Workshop on Career Guidance',
    description:
      'Meet with a Quadrant-i Principal to discuss the patent process and commercialization opportunities for your research.',
    color: 'rgb(14 80 58)',
  },
];

const EventCard = ({ day, date, title, description, color }) => {
  const [calendarMessage, setCalendarMessage] = React.useState('');

  const handleAddToCalendar = () => {
    // You can integrate the functionality to open a calendar app or create a calendar event link here
    setCalendarMessage('Calendar integration is not available yet.');
  };

  return (
    <div
      className="border border-[#c5b358] bg-white p-6 rounded-lg shadow-lg max-w-sm transition-transform transform hover:scale-105 hover:shadow-2xl hover:shadow-[#c5b358] ease-in-out duration-300 relative"
      aria-label={`${title} event happening on ${day}, ${date}`}
    >
      {/* Add to Calendar icon */}
      <div
        onClick={handleAddToCalendar}
        className="absolute top-2 right-2 text-xl text-[#c5b358] cursor-pointer"
        title="Add to Calendar"
      >
        <FaCalendarPlus />
      </div>

      <div className="flex items-center mb-4">
        <div
          style={{ backgroundColor: color }}
          className="text-white px-4 py-2 text-lg font-bold rounded-md shadow-lg"
        >
          {day}
        </div>
        <div className="ml-4 text-2xl font-semibold text-gray-800">{date}</div>
      </div>
      <h4 className="text-xl font-semibold text-gray-800 mb-2">{title}</h4>
      <p className="text-sm text-gray-600 mb-4">{description}</p>
      {calendarMessage && (
        <p className="text-xs font-semibold text-[#13294b]" aria-live="polite">
          {calendarMessage}
        </p>
      )}
      <div className="flex justify-center">
        <button className="mt-4 bg-[#c5b358] text-white py-2 px-6 rounded-lg hover:bg-[#b29b4a] transition-colors ease-in-out duration-200">
          Read More &raquo;
        </button>

      </div>
    </div>
  );
};

const EventsSection = () => {
  // Sort events by date
  const sortedEvents = [...events].sort((a, b) => {
    const dateA = new Date(a.date);
    const dateB = new Date(b.date);
    return dateA - dateB;
  });

  return (
    <section
      className="p-8 min-h-screen"
      style={{
        backgroundColor: theme.SuccessStories.backgroundColor,
        fontFamily: theme.SuccessStories.fontFamily,
      }}
    >
      <div className="container mx-auto p-8" style={{ backgroundColor: '#13294b' }}>
        <h2
          className="text-5xl font-bold mb-6 text-white relative text-center"
          style={{ paddingBottom: '15px' }}
        >
          Mark Your Calendars <span className="mr-2">📅</span>
        </h2>


        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {sortedEvents.map((event, index) => (
            <EventCard key={index} {...event} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default EventsSection;
